import React from "react";

import styles from "./RadioButton.module.scss";

type Props = {
  label: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const RadioButton: React.FC<Props> = ({ label, ...rest }) => {
  return (
    <>
      <label>
        <input
          type="radio"
          name={rest.name}
          value={rest.value}
          checked={rest.checked}
          onChange={rest.onChange}
          className={styles.radio}
        />
        {label}
      </label>
    </>
  );
};

export default RadioButton;
